import React from 'react';
import { Link } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import theme from '../../../muiTheme';

const styles = {
  header: {
    color: theme.palette.accent1Color
  },
  body: {
    width: '100%',
    textAlign: 'center',
    padding: '100px',
    background: '#eceff5'
  }
};

const InvalidIdPage = ({ id, onClose }) => {
  return (
    <div style={styles.body}>
      <h1 style={styles.header}>Oops!</h1>
      <p>
        <strong>{id}</strong> is not a valid IrwinID.
      </p>
      <p>
        <Link to={`/incidents/${window.location.search}`}>
          <RaisedButton label="Back to All Incidents" />
        </Link>
      </p>
    </div>
  );
};

export default InvalidIdPage;



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/InvalidIdPage.js